import redNftHolder from '../assets/greenpill/redNftHolder.png';
import yellowNftHolder from '../assets/greenpill/yellowNftHolder.png';
import greenNftHolder from '../assets/greenpill/greenNftHolder.png';

export const greenPillFAQsData = [
    {
        id: 1,
        question: 'What is the Greenpill Event on Impact Foundry?',
        answer: [
            'The Greenpill Event on Impact Foundry allows organizations to create bounties and individuals to mint and transform Red Pill NFTs into Green Pills by completing actions tied to Foundry such as creating bounties (the full list is at the end of this list as well as in the ‘Achievements’ section the Greenpill Collection )',
        ],
        links: [
            // {
            //     text: 'Step by step walkthrough',
            //     href: 'https://app.tango.us/app/workflow/Creating-a-New-Organization-d173295344464bfa96bedd949d8b3873',
            // },
        ],
    },
    {
        id: 2,
        question: 'What is the Red Pill NFT?',
        answer: [
            'It starts red and mutates as you do more actions, eventually turning green after you’ve reached 3600 IP, reflecting the real world impact',
        ],
        imagesData: [
            {
                isArrow: false,
                image: redNftHolder,
                fundPercent: 40,
                ips: 1440,
                color: 'red',
            },
            {
                isArrow: true,
            },
            {
                isArrow: false,
                image: yellowNftHolder,
                fundPercent: 50,
                ips: 1800,
                color: 'yellow',
            },
            {
                isArrow: true,
            },
            {
                isArrow: false,
                image: greenNftHolder,
                fundPercent: 100,
                ips: 3600,
                color: 'green',
            },
        ],
        links: [],
    },
    {
        id: 3,
        question: 'Who can participate in the GreenPill Event on Foundry?',
        answer: [
            `Whitelisted Organizations: Can create bounties as part of the event.
Anyone: Can mint $5 Red Pill NFTs and transform them into Green Pills via actions`,
        ],
        links: [],
    },
    {
        id: 4,
        question: 'Can participants mint multiple NFTs?',
        answer: [
            'Yes, you can mint multiple Red Pill NFTs from the same or different collection. However, each collection has a cap of 400 Pills that can turn green, so transform them quickly!',
        ],
        links: [],
    },
    {
        id: 5,
        question: 'How are Greenpill bounties funded on Foundry?',
        answer: [
            `Greenpills can be funded through:
- Contributions from the organisation itself
- From Impact Landscapes, a platform for bounty backers`,
        ],
        links: [],
    },
    {
        id: 6,
        question: 'Why should I participate in the Greenpill Event on Foundry?',
        answer: ['It’s an opportunity to actively support climate-positive actions and earn special rewards!'],
        links: [],
    },

    {
        id: 7,
        question: 'List of all actions to gain IP',
        lists: [
            '1. Creating and Publishing a Bounty - 20 IP',
            // '2. Creating and Publishing 10 Bounties - 200 IP',
            // '3. Creating and Publishing 100 Bounties - 2,000 IP',
            '2. Create an Organization - 100 IP',
            '3. Grow Organization to 10 Members - 500 IP',
            // '6. Grow Organization to 100 Members - 5,000 IP',
            // '7. Grow Organization to 1000 Members - 50,000 IP',
            '4. Create a Project with 10 Bounties - 100 IP',
            // '9. Create a Project with 10 Bounties Validated and Paid Out - 250 IP',
            // '10. Create a Project with 100 Bounties Validated and Paid Out - 1,000 IP',
            '5. Issue 10 Impact Certificates - 100 IP',
            // '10. Issue 100 Impact Certificates - 1,000 IP',
            '6. Validate 10 Bounty Submissions - 100 IP',
            // '12. Validate 100 Bounty Submissions - 1,000 IP',
            // '15. Store Data on Chain - 1,000 IP',
            // '13. Deployed $100 in Impact Funds',
            // '14. Deployed $1,000 in Impact Funds',
            // '15. Deployed $10,000 in Impact Funds',
        ],
        answer: [''],
        links: [],
    },
];
